import { SvgIcon } from "@peerup/vue-ui"
import { Spin } from "ant-design-vue"
import { h } from "vue"

/**
 * 现在已采用 unplugin-vue-components 自动按需引入 ant-design-vue 组件，无需全局 use。
 * 仅保留 Spin 的默认指示器设置。
 */
export function setupAntd() {
  Spin.setDefaultIndicator({
    indicator: h(SvgIcon, {
      name: "common-loading",
      class: "anticon-spin",
      style: {
        fontSize: "36px",
        // color: '#939aa3'
      },
      spin: true,
    }),
  })
}
